import setup from './moduleSetup';

export default {
    name: 'fulfillment',
    before: [],
    after: [],
    setup,
};
